import { useState, useEffect } from 'react';
import { SimpleTextCard } from './simple-text-card';
import { AchievementCard } from './achievement-card';
import { TrustIndicator } from './trust-indicator';
import { QuoteCard } from './quote-card';
import { ExperienceSection } from './experience-section';
import { ProfileSection } from './profile-section';
import { FeatureCard } from './feature-card';
import { AvailabilityCard } from './availability-card';

// Import SVG assets
import zapIcon from '../../assets/zapIcon.svg';
import rocketIcon from '../../assets/rocketIcon.svg';

export function AboutMe() {
  const [isLargeScreen, setIsLargeScreen] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 1381);
    };

    // Check initial size
    checkScreenSize();

    // Add resize listener
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  if (isLargeScreen) {
    // Original 5x6 bento grid layout for screens >= 1381px
    return (
      <section 
        id="about-me" 
        className="py-20 px-6 md:px-12 lg:px-16"
      >
        <div className="w-full max-w-7xl mx-auto">
          {/* 5x6 Bento Grid */}
          <div className="grid grid-cols-5 gap-4">

            {/* Column 1, Row 1 - Streamline Processes */}
            <SimpleTextCard text="Creative Delivery" />

            {/* Column 2, Rows 1-2 - Full-Stack Internship */}
<AchievementCard 
  title={<>Full-Stack Dev<br />Internship<br />2024</>}
  description="Next24Tech Technology & Services"
  className="row-span-2"
/>

{/* Column 3, Rows 1-2 - Hackathon Recognition */}
<AchievementCard 
  title={<>Hackathon<br />Performer<br />2023</>}
  description="Recognized for MERN-based project"
  className="row-span-2"
/>

{/* Column 4, Rows 1-2 - Project Milestone */}
<AchievementCard 
  title={<>10+ Projects<br />Built Across<br />Web</>}
  description="MERN • Next.js • GSAP • APIs"
  className="row-span-2"
/>


            {/* Column 5, Rows 1-3 - Business-First Tech Leader */}
            <QuoteCard />

            {/* Column 1, Row 2 - Trusted by AccuraCast */}
            {/* <TrustIndicator /> */}

            {/* Column 1, Rows 3-6 - Experience */}
            <ExperienceSection />

            {/* Columns 2-4, Rows 3-5 - Image and Bio */}
            <ProfileSection />

            {/* Column 5, Row 4 - Scalable solutions */}
            <FeatureCard 
              icon={zapIcon} 
              text={<>Scalable<br/>Solutions</>}
              altText="Scalable solutions"
              variant="text-left-icon-right"
            />

            {/* Column 5, Row 5 - Prototype to Production */}
            <FeatureCard 
              icon={rocketIcon} 
              text={<>Idea<br/>to Production</>}
              altText="Idea to Production"
              variant="text-right-icon-left"
            />

            {/* Columns 2-4, Row 6 - Accepting 2 new clients */}
            <AvailabilityCard />

            {/* Column 5, Row 6 - Enterprise Compliance Standards */}
            <SimpleTextCard text="Compliance Standards" />
            
          </div>
        </div>
      </section>
    );
  }

// Compact layout for screens < 1381px
return (
  <section 
    id="about-me" 
    className="py-20 px-6 md:px-12 lg:px-16"
  >
    <div className="w-full max-w-7xl mx-auto">
      <div className="flex flex-col gap-4">
        
        {/* Row 1: 3 AchievementCards (same as big layout) */}
        <div className="grid grid-cols-3 gap-4">
          <AchievementCard 
            title={<>Full-Stack Dev<br />Internship<br />2024</>}
            description="Next24Tech Technology & Services"
          />
          <AchievementCard 
            title={<>Hackathon<br />Performer<br />2023</>}
            description="Recognized for MERN-based project"
          />
          <AchievementCard 
            title={<>10+ Projects<br />Built Across<br />Web</>}
            description="MERN • Next.js • GSAP • APIs"
          />
        </div>

        {/* Row 2: ProfileSection */}
        <div className="w-full">
          <ProfileSection />
        </div>

        {/* Row 3: 2 FeatureCards + 1 SimpleTextCard */}
        <div className="flex flex-col gap-4">
          <div className="grid grid-cols-2 [@media(min-width:1175px)]:grid-cols-3 gap-4">
            <FeatureCard 
              icon={rocketIcon} 
              text={<>Idea<br/>to Production</>}
              altText="Idea to Production"
              variant="text-right-icon-left"
            />
            <FeatureCard 
              icon={zapIcon} 
              text={<>Scalable<br/>Solutions</>}
              altText="Scalable solutions"
              variant="text-left-icon-right"
            />
            <div className="hidden [@media(min-width:1175px)]:block">
              <SimpleTextCard text="Compliance Standards" />
            </div>
          </div>
          
          <div className="[@media(min-width:1175px)]:hidden">
            <SimpleTextCard text="Compliance Standards" />
          </div>
        </div>

        {/* Row 4: Complex 2x3 grid */}
        <div className="grid grid-cols-3 grid-rows-2 gap-4">
          <div className="col-start-1 row-start-1">
            <SimpleTextCard text="Creative Delivery" />
          </div>
          
          <div className="col-start-1 row-start-2">
            <TrustIndicator />
          </div>
          
          <div className="col-start-2 col-span-2 row-start-1 row-span-2">
            <QuoteCard />
          </div>
        </div>

        {/* Row 5: ExperienceSection */}
        <div className="w-full">
          <ExperienceSection />
        </div>

      </div>
    </div>
  </section>
);

}